export default "__VITE_ASSET__CHzlnKs9__"